import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ACTIVITY_SECTIONS, AWARD_FILE_CATEGORY_TYPES } from 'constants/enums'
import { get } from 'lodash'
import { injectIntl } from 'react-intl'
import { AwardFiles } from 'containers/pages'
import { FileCard, Title } from 'components/misc'
import { DashboardGrid as Grid } from 'components/layout'

@injectIntl
class AJFiles extends Component {
  static propTypes = {
    event: PropTypes.object,
    intl: PropTypes.func
  }

  render() {
    const { event, intl } = this.props

    return (
      <div>
        <AwardFiles
          sectionId={ACTIVITY_SECTIONS.adventurous_journey.id}
          category={AWARD_FILE_CATEGORY_TYPES.adventureJourney.id}
          {...this.props}
        />

        {get(event, 'fileUrls.length', 0) > 0 && (
          <Grid.RightInner>
            <Title intlKey="moduleTitle.attached_with_observation" h2>
              Attached with observation
            </Title>
            <div className="row">
              {get(event, 'fileUrls', []).map((src, index) => (
                <div className="col-xs-12 col-md-6" key={src}>
                  <FileCard
                    src={src}
                    file={{
                      title: `${intl.formatMessage({
                        id: 'label.attached_file',
                        defaultMessage: 'Attached file'
                      })} ${++index}`
                    }}
                  />
                </div>
              ))}
            </div>
          </Grid.RightInner>
        )}
      </div>
    )
  }
}

export default AJFiles
